import { render, staticRenderFns } from "./product-service-multiselect-ajax.vue?vue&type=template&id=9851bb48&scoped=true&"
import script from "./product-service-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./product-service-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9851bb48",
  null
  
)

export default component.exports